import { useFilterJobGradeContext } from "./filter-job-grade.context";

export function FilterJobGrade() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterJobGradeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}